import {
  ChangeDetectionStrategy,
  Component,
  Input,
  EventEmitter,
  Output,
  OnInit,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { FacilityItemInformation } from 'src/app/common/models/facilityItemInformation';
import { ItemGroup } from 'src/app/common/models/itemGroup';
import { ItemGroupEntity } from 'src/app/common/models/itemGroupEntity';
import { AuthManager } from 'src/app/core/auth/auth.manager';
import { DecimalPipe } from '@angular/common';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { PrepMinutesFormatPipe, LeadMinutesFormatPipe } from '@pipes/minutes-hours-pipe';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-item-group-tile',
  templateUrl: './item-group-tile.component.html',
  styleUrl: './item-group-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatSlideToggle, FormsModule, DecimalPipe, PrepMinutesFormatPipe, LeadMinutesFormatPipe, MatIconModule],
})
export class ItemGroupTileComponent implements OnInit, OnChanges {
  @Input() public viewModel!: ItemGroupEntity;
  @Output() public externalItemNumberAvailabilityEmit: EventEmitter<ItemGroup> = new EventEmitter<ItemGroup>();
  @Output() public externalItemNumberEditEmit: EventEmitter<void> = new EventEmitter<void>();
  @Output() public externalItemNumberStockRefreshEmit: EventEmitter<void> = new EventEmitter<void>();
  @Output() public resolveInconsistencyEmit: EventEmitter<ItemGroupEntity> = new EventEmitter<ItemGroupEntity>();

  public isExternalItemNumberGroup!: boolean;
  public isCommodityGroup!: boolean;
  public authManager: AuthManager;
  private readonly handoffTypes: string[] = ['store', 'curbside', 'delivery', 'kiosk', 'tableside'];

  constructor(private readonly auth: AuthManager) {
    this.authManager = this.auth;
  }

  public ngOnInit(): void {
    this.isCommodityGroup = this.viewModel.isCommodityGroup;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['viewModel']) {
      this.isCommodityGroup = this.viewModel.isCommodityGroup;
    }
  }

  public editExternalItemNumberGroup(): void {
    this.externalItemNumberEditEmit.emit();
  }

  public externalItemNumberAvailability(itemGroup: ItemGroup): void {
    this.externalItemNumberAvailabilityEmit.emit(itemGroup);
  }

  public externalItemNumberStockRefresh(): void {
    this.externalItemNumberStockRefreshEmit.emit();
  }

  public resolveInconsistency(): void {
    this.resolveInconsistencyEmit.emit(this.viewModel);
  }

  private formatDate(date?: Date | null): string {
    if (date) {
      date = new Date(date);
      const month: string = (date.getMonth() + 1).toString().padStart(2, '0');
      const day: string = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();
      return month + '/' + day + '/' + year;
    }
    return 'N/A';
  }

  public getFormattedPickupDates(item: FacilityItemInformation): string {
    return this._displayPickupDates(item)
      ? `${this.formatDate(item.startPickupDate)} - ${this.formatDate(item.endPickupDate)}`
      : 'Any';
  }

  public displayHandoffTypes(item: FacilityItemInformation): boolean {
    return (item.allowedHandoffTypes?.length ?? 0) > 0 && (item.allowedHandoffTypes?.length ?? 0) < 5;
  }

  public getHandoffRestrictions(item: FacilityItemInformation): string[] {
    return this.handoffTypes
      .filter((x) => !item.allowedHandoffTypes?.includes(x))
      .map((x) => x.charAt(0).toUpperCase() + x.slice(1));
  }

  private _displayPickupDates(item: FacilityItemInformation): boolean {
    return (
      item.startPickupDate !== null
      && item.startPickupDate !== undefined
      && item.endPickupDate !== null
      && item.endPickupDate !== undefined
    );
  }
}
